import React, { useEffect, useImperativeHandle } from "react";
import { Button, TextField, Switch, Typography, MenuItem } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import {DialogContent, DialogContentText} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import CloseIcon from "@mui/icons-material/Close";
import Settings from "@mui/icons-material/Settings";
import { userService } from "../../services/user.service";
import currency from "../../helpers/currencies.json";
import { toast } from "react-toastify";
import axiosInstance from "../../interceptor/interceptor";
import CircularProgress from "@mui/material/CircularProgress";
import { userActions } from '../../actions/user.actions';
import { varsActions } from '../../actions/vars.action';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
// time update variable
import { months } from "../../helpers/constants";
import { clearLocalData } from "../../helpers/common";
// time update variable
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const SettingsDialog = React.forwardRef((props, ref) => {
  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = React.useState(false);
  // time update variable...
  const [month, setMonth] = React.useState(""); // It stores month name in string
  const [year, setYear] = React.useState(new Date().getFullYear()); // '2023-01-05'
  const [monthId, setMonthId] = React.useState(""); // Value stores from 0 - 11
  const [endDate, setEndDate] = React.useState({});
  const [fullName, setFullName] = React.useState("");
   const [hideIncome, setHideIncome] = React.useState(false);
  // time update variable...
  const dispatch = useDispatch();
  const [inputField, setInputField] = React.useState({
    currency: "",
    month_start_date: "",
    hide_income: "",    
    });

  useEffect(()=>{
    fetchSettings();
  }, []);

  useImperativeHandle(ref, () => ({
    childFunction1() {
      handleClickOpen();
      fetchSettings();
    },
  }))

  function fetchSettings(){
    setFullName(userService.decryptData(localStorage.getItem('user_text_obj_data2'),'base64'));
    const user_id = localStorage.getItem('user_text_obj_data1');
    userService.fetchSettings({user_id: user_id}).then(
      (response) => {
        if(response.data.status === 200){
          setInputField({ currency: response.data.result.currency, month_start_date: response.data.result.month_start_date });  
          setHideIncome(response.data.result.hide_income === 0 ? false : true);
        }
        else {
          toast.info(response.data.message, { type: "error" });
        }
      }
    ).catch(err=>{
      if(err.code !== 'ERR_NETWORK'){
        toast.info(err && err.response && err.response.data && err.response.data.message ? err.response.data.message : "Check Your Internet Connection.", { type: "error" });
      }
    });
  }

  const inputsHandler = (e) => {
    setInputField({ ...inputField, [e.target.name]: e.target.value });
  };

  if (props.budgetDialog) {
    setOpen(props.budgetDialog);
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleClose2 = () => {
    setOpen2(false);
  };

  const handleSubmit = async () => {
    if (!inputField.currency) {
      toast.info("Currency can not be empty", { type: "error" });
      return false;
    }
    if (!inputField.month_start_date) {
      toast.info("First Day of Month can not be empty", { type: "error" });
      return false;
    }

    try {
      let obj = {
        ...inputField,
        user_id: localStorage.getItem("user_text_obj_data1"),
        hide_income: hideIncome
      };
      
      setIsLoading(true);
      const res = await axiosInstance.post(
        `api?method=update_user`,
        obj
      );
      setIsLoading(false);
      toast(res.data.message);
      const foundCurrency = currency.find(element => element.code == inputField.currency);
      const oldCurrency = localStorage.getItem('currency');
      const oldHideIncome = localStorage.getItem('items_text_obj2') ? true : false;
      // setInputField({ currency: foundCurrency.currency, month_start_date: inputField.month_start_date });
      if(localStorage.getItem('monthStartDate') != inputField.month_start_date){
        localStorage.setItem('monthStartDate',inputField.month_start_date);
        updateReduxStore();
      }
      if(oldCurrency != foundCurrency.symbol){
        localStorage.setItem('currency',foundCurrency.symbol);
        updateUserCurrency({currency: foundCurrency.symbol});
      }
      
      if(oldHideIncome != hideIncome){
        if(hideIncome == true){
          localStorage.setItem('items_text_obj2', 1 );
        } else {
          localStorage.removeItem('items_text_obj2');
        }  
        dispatch(userActions.updateUserSettings({hideIncome: hideIncome}));
      }
      setOpen(false);
    } catch (e) {
      toast.info(`Error: ${e}`, { type: "error" });
    }
  };

  function updateUserCurrency(obj){
    dispatch(userActions.updateCurrency(obj));
  }

  function updateReduxStore(){
    const d = new Date(); //'2023-01-05'
    setYear(d.getFullYear());
    let curMonthId = d.getMonth() + 1;
    let curYear;
    if(d.getDate() < parseInt(localStorage.getItem("monthStartDate"))){
      if(d.getMonth() == 0){ // If its january and value is passing 0 in setCurrentMonth function
        setCurrentMonth(12);
        setMonthId(11);
        curMonthId = 12;
        setYear(year-1);
        curYear = year -1;
      } else {
        curMonthId = curMonthId - 1;
        curYear = year;
        setCurrentMonth(d.getMonth());
        setMonthId(d.getMonth());
      }
      dispatchStartDate(
        new Date(`${curYear}-${curMonthId.toString().padStart(2, '0')}-${localStorage.getItem("monthStartDate").toString().padStart(2, '0')}`)
      );
      getEndDate(curMonthId, curYear);
    }
    else if (curMonthId == 12) {
      setMonthId(curMonthId);
      setCurrentMonth(curMonthId);
      curYear = year;
      dispatchStartDate(
        new Date(`${curYear}-${curMonthId.toString().padStart(2, '0')}-${localStorage.getItem("monthStartDate").toString().padStart(2, '0')}`)
      );
      getEndDate(curMonthId, curYear);
    } else {
      setMonthId(curMonthId);
      setCurrentMonth(curMonthId);
      curYear = year;
      dispatchStartDate(
        new Date(
          `${year}-${curMonthId.toString().padStart(2, '0')}-${localStorage.getItem("monthStartDate").toString().padStart(2, '0')}`
        )
      );
      getEndDate(curMonthId, curYear);
    }
  }

  const setCurrentMonth = (mId) => {
    setMonth(months[mId-1].name);
  };

  function dispatchStartDate(date) {
    dispatch(
      varsActions.setStartDate({
        startDate: `${date.getFullYear()}-${
          date.getMonth() + 1
        }-${date.getDate()}`,
      })
    );
  }

  const getEndDate = (monthVal, yearVal) => { // value receives here in 1-12
    const days = months[monthVal - 1].days - 1;
    var date = new Date(
      `${yearVal}-${monthVal}-${localStorage.getItem("monthStartDate")}`
    ); //.toISOString().split("T")[0]
    
    date.setDate(date.getDate() + days);
    setEndDate({
      date: date.getDate(),
      monthId: date.getMonth() + 1,
      monthString: months[date.getMonth()].name,
      year: date.getFullYear(),
    });
    dispatchEndDate(
      `${new Date(date).getFullYear()}-${
        (new Date(date).getMonth() + 1).toString().padStart(2, '0')
      }-${(new Date(date).getDate()).toString().padStart(2, '0')}`
    );
  };

  function dispatchEndDate(date) {
    dispatch(
      varsActions.setEndDate({
        endDate: date,
      })
    );
  }

  const deleteAccount = () => {
    setOpen2(true);
  }

  const confirmDeleteAccount =async () => {
    setOpen2(false);
    // Code to delete the user data...
    setIsLoading(true);
    const delObj = {
      user_id:localStorage.getItem('user_text_obj_data1')
    }
    const res = await axiosInstance.delete(
      `api?method=delete_account`,
      {data: delObj}
    );

    setIsLoading(false);
    clearLocalData();
    navigate({
      pathname: "/",
      search: "?operation=delete_account",
    });

  }

  return (
    <div className="settingDialog">
      <Dialog
        open={open2}
        onClose={handleClose2}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure to delete?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Data will be permanently erased from the Application server which you can not recover later.
            Agree if you still want to delete account.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose2} variant="outlined">Disagree</Button>
          <Button onClick={confirmDeleteAccount} autoFocus variant="outlined">
            Agree
          </Button>
        </DialogActions>
      </Dialog>

      {/* <Typography onClick={handleClickOpen}  sx={{display:"flex", alignItems:"center"}}>
        <Settings fontSize="small" sx={{marginRight:"5px"}} /> Settings
      </Typography> */}
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
         <Typography style={{display:'flex', padding:'10px'}}><strong>{fullName}</strong></Typography><br/>
        <CloseIcon
          onClick={handleClose}
          sx={{
            position: "absolute",
            cursor: "pointer",
            right: 10,
            top: 10,
            color: (theme) => theme.palette.grey[500],
          }}
        />
        <DialogTitle 
        sx={{
          display:"flex",
          alignItems:"center",
          padding: "0px 24px",
        }}>
         
          <Settings fontSize="medium" sx={{marginRight:"3px"}}/>
          Settings
          &nbsp; &nbsp;
          <Button variant="outlined" onClick={deleteAccount} color="error">
            Delete Account
          </Button>
        </DialogTitle>
        <DialogContent  sx={{
          paddingTop:"20px !important"
        }}>
          <form>
            <br />
            <TextField
              id="Select Currency"
              name="currency"
              style={{ width: "100%" }}
              select
              label="currency"
              value={inputField.currency}
              onChange={inputsHandler}
            >
              {currency.map((option) => (
                <MenuItem key={option.code} value={option.code}>
                  {option.name}({option.symbol})
                </MenuItem>
              ))}
            </TextField>
            <br />
            <br />
            <TextField
              name="month_start_date"
              type="text"
              label="First Day of Month"
              variant="outlined"
              value={inputField.month_start_date}
              onChange={inputsHandler}
            />
            <br/><br/>
            Hide Income
            <Switch onClick={() => setHideIncome(!hideIncome)} checked={hideIncome}
            />
          </form>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleSubmit} variant="outlined">Save</Button>
        </DialogActions>
      </Dialog>

      {isLoading == false ? (
        <></>
      ) : (
        <div id="overlay">
          <div className="loader">
            <CircularProgress />
          </div>
        </div>
      )}

    </div>
  );
})

export default SettingsDialog
